import { useEffect } from "react";
import { Anchor, Modal, Table } from "@mantine/core";
import { withTranslation } from "react-i18next";
import { useState } from "react";

const ApplicationModal = ({ opened, setOpened, apps, viewJobId }) => {
  const [candidates, setCandidates] = useState([]);
  useEffect(() => {
    apps.map((obj) => {
      if (obj._id === viewJobId.id) {
        setCandidates(obj.appliedCandidates);
      }
    });
  }, [apps, viewJobId]);
  const handleClose = () => {
    setOpened(false);
  };
  const rows = candidates?.map((obj) => {
    let resume=obj.user?.jobSeeker[0]?.jobSeekerDocuments.filter(n=>n._id===obj?.documnetId)
    return (
      <tr>
        <td>{obj.user.displayName}</td>
        <td>
          <Anchor href={resume?.[0]?.document} target="_blank">
            Resume
          </Anchor>
        </td>
      </tr>
    );
  });
  return (
    <>
      <Modal
        styles={{
          title: {
            width: "100%",
            textAlign: "center",
            paddingLeft: "10px",
          },
        }}
        opened={opened}
        centered
        onClose={handleClose}
        title={`Applications for ${viewJobId.name}`}
      >
        <Table>
          <thead>
            <tr>
              <th>Applicant Name</th>
              <th>Resume</th>
            </tr>
          </thead>
          {candidates && <tbody>{rows}</tbody>}
        </Table>
        {candidates.length < 1 && (
          <h5 className="text-dark text-center m-3">No Applications</h5>
        )}
      </Modal>
    </>
  );
};
export default withTranslation()(ApplicationModal);
